import { Avatar as FbAvatar, AvatarProps as FbAvatarProps } from "flowbite-react"
import { merge } from "lodash"
import React, { useRef } from "react"
import { HiPencil } from "react-icons/hi"
import { showToast } from "src/components/toast"
import { UserType } from "src/utils/proptypes"
import { getInitials } from "src/utils/string.util"
import { twMerge } from "tailwind-merge"

type AvatarProps = FbAvatarProps & {
   editMode?: boolean
   onEdit?: (file: File) => void
   user?: Partial<UserType> | null
}

const initialTheme = {
   root: {
      rounded: "min-w-8 min-h-8 rounded-full",
      initials: {
         base: 'bg-border border border-white min-w-8 min-h-8',
         text: "font-semibold text-xs text-center text-black"
      },
      img: {
         base: 'max-w-full h-auto rounded object-cover',
      }
   }
}

const Avatar: React.FC<AvatarProps> = ({ editMode = false, user, theme, onEdit, ...props }) => {
   const firstName = user?.firstName || ''
   const lastName = user?.lastName || ''
   const emailAddress = user?.emailAddress || ''
   const avatar = user?.fileImage?.s3Path
   const finalTheme = merge({}, initialTheme, theme || {})
   const cursor = editMode === true ? 'cursor-pointer' : ''

   // For avatar upload
   const inputRef = useRef<HTMLInputElement | null>(null);

   const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      e.preventDefault()
      e.stopPropagation()

      const file = e.target.files?.[0] as File;
      if (file && file.type.startsWith('image/')) {
         onEdit?.(file);
      } else {
         showToast('error', 'The selected file type is not image');
      }
   };

   return (
      <div
         className={twMerge("relative", cursor)}
         onClick={editMode
            ? (_e) => {
               inputRef.current?.click();
            }
            : undefined}
      >
         <FbAvatar
            img={avatar}
            theme={finalTheme}
            rounded size="sm"
            placeholderInitials={getInitials(firstName, lastName) || emailAddress?.substring(0, 2).toUpperCase()}
            {...props}
         />
         {editMode === true &&
            <>
               <div className="absolute bottom-0 right-0 flex items-center justify-center bg-black hover:bg-gray-500 rounded w-5 h-5">
                  <HiPencil color="white" size={10} />
               </div>
               <input
                  type="file"
                  accept="image/*"
                  ref={inputRef}
                  onChange={handleFileChange}
                  className="hidden"
               />
            </>
         }

      </div>
   )
}

export default Avatar